import { t } from './config'
import { uploadAttachment, removeAttachment, isRateLimited } from './api'
import { escapeHTML } from './richText'
import closeIcon from '../../../images/icons/close-midnight-black-40.svg'

export default function createAttachments (container, { onError, onChange }) {
  let pending = []
  let generation = 0
  let conversationId

  container.addEventListener('click', event => {
    const button = event.target.closest('.vjs-vera-attachment-remove')
    if (button) remove(button.closest('.vjs-vera-attachment').dataset.attachmentId)
  })

  function clear () {
    pending = []
    render()
  }

  // Another conversation: an upload still on its way belongs to the one left behind.
  function reset () {
    generation += 1
    clear()
  }

  function take () {
    const taken = pending
    clear()
    return taken
  }

  function restore (attachments) {
    if (pending.length > 0 || attachments.length === 0) return
    pending = attachments
    render()
  }

  // True once the photo is in the composer. The conversation is asked for only
  // after the file passes, as asking may create it.
  async function add (whenConversation, file) {
    if (!['image/jpeg', 'image/png', 'image/gif', 'image/webp'].includes(file.type)) return onError(t('attachment.wrong_type'))
    if (file.size > 20 * 1024 * 1024) return onError(t('attachment.too_large'))

    const started = generation
    let uploadedTo
    try {
      uploadedTo = await whenConversation()
      const uploaded = await uploadAttachment(uploadedTo, file)
      if (started !== generation) {
        removeAttachment(uploadedTo, uploaded.id).catch(() => {})
        return false
      }
      conversationId = uploadedTo
      pending.forEach(replaced => discard(replaced.id))
      pending = [uploaded]
      render()
      return true
    } catch (error) {
      if (started === generation) onError(isRateLimited(error) ? t('errors.rate_limited') : t('attachment.failed'))
      return false
    }
  }

  function remove (attachmentId) {
    pending = pending.filter(item => item.id !== attachmentId)
    render()
    discard(attachmentId)
  }

  function discard (attachmentId) {
    if (conversationId) removeAttachment(conversationId, attachmentId).catch(() => {})
  }

  function render () {
    container.innerHTML = pending.map(attachment => `
      <div class="inline-flex items-center gap-8 py-6 pr-10 pl-6 bg-bone-white rounded vjs-vera-attachment" data-attachment-id="${attachment.id}">
        <img class="vsd-vera-attachment__thumb" src="${escapeHTML(attachment.url)}" alt="">
        <span class="vsd-vera-attachment__name">${escapeHTML(attachment.filename || '')}</span>
        <button type="button" class="vsd-vera-attachment__remove vjs-vera-attachment-remove" aria-label="${t('attachment.remove')}">
          <img src="${closeIcon}" alt="">
        </button>
      </div>
    `).join('')
    onChange?.()
  }

  return {
    get ids () {
      return pending.map(attachment => attachment.id)
    },
    get pending () {
      return pending
    },
    add,
    clear,
    reset,
    take,
    restore
  }
}
